import React, { useLayoutEffect, useState, useEffect } from 'react';
import DashboardDumb from './DashboardDumb';
import queryString from 'query-string';
import withRequest from 'hoc/withRequest';
import { useUser, useDashboard, useTemplate, useJob } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import { CircularProgress, Backdrop } from '@mui/material';
import { ErrorScreen, Alert, ModalJobAlert } from 'components/common';
import { withRouter, useHistory } from 'react-router-dom';
import { JobSchema } from 'schemas';
import { ROUTES } from 'consts';
import moment from 'moment';


const today = moment(new Date()).unix() * 1000;
const priorDate = moment(new Date()).subtract(3, 'months').unix() * 1000;

const DashboardSmart = (props) => {
  const { parameters, filters, setFilters } = useUser();
  const projects = formatProjectItems(parameters);
  const projectsMap = projects.reduce((a, v) => ({ ...a, [v.value]: v}), {});
  const history = useHistory();
  const template = useTemplate();
  const job = useJob();
  const [openModalRunJob, setOpenModalRunJob] = useState(false);
  const [workflowSelected, setWorkflowSelected] = useState(null);
  const { error, isLoaded, data, getDashboard } = useDashboard();
  const [runError, setRunError] = useState(0);

  let {
    project=filters.project,
    dateFrom=priorDate,
    dateTo=today
  } = queryString.parse(props.location.search);

  const [defaultValues, setDefaultValues] = useState({
    dateFrom: Number(priorDate),
    dateTo: Number(today),
    project: project || projects[0].value
  });

  const handleListPage = () => {
    const dateFromQuery = Number(dateFrom);
    const dateToQuery = Number(dateTo);
    if (project !== filters.project) setFilters({ project });
    if (project && !!projectsMap[project]) {
      getDashboard({
        query: {
          projectId: project,
          baseUrl: projectsMap[project].base_url,
          dateFrom: moment(dateFromQuery).format('YYYY-MM-DD'),
          dateTo: moment(dateToQuery).format('YYYY-MM-DD'),
          type: 'SI',
        },
      });
    } else {
      history.push(`?project=${projects[0].value}&dateFrom=${dateFromQuery}&dateTo=${dateToQuery}`);
    }
  };

  const handleSearch = (data) => {
    const newDateFrom = moment(data.dateFrom).unix() * 1000;
    const newDateTo = moment(data.dateTo).unix() * 1000;

    const routeToPush = `${ROUTES.HOME}?project=${data.project}&dateFrom=${newDateFrom}&dateTo=${newDateTo}`;
    setDefaultValues({
      dateFrom: newDateFrom, dateTo: newDateTo, project: data.project
    });
    history.push(routeToPush);
  }

  const handleRedirect = () => history.push(ROUTES.WORKFLOW_LIST);

  const handleRunJob = (data) => {
    let { worktemplate_id, wf_definition, name, type } = workflowSelected;
    const jobsDefinitions = {};
    const userInteraction = [];

    JSON.parse(wf_definition).forEach(wf => {
      if (wf?.length) {
        wf.forEach((i) => {
          jobsDefinitions[i.id_Plantilla] = i;
        });
      } else jobsDefinitions[wf.id_Plantilla] = wf;
    });

    for (const key in data) {
      const job = jobsDefinitions[key];
      if (job) {
        userInteraction.push({
          ...data[key],
          id_nodo: job.id_nodo
        });
      }
    };

    const jobToRun = new JobSchema();
    jobToRun.setValues({
      userInteraction,
      worktemplate_id,
      name,
      type
    });

    job.postJobRun({
      body: { ...jobToRun.values },
    });
    setOpenModalRunJob(false);
  };

  const handleModalRunJob = (workflow) => {
    const definitions = JSON.parse(workflow.wf_definition);

    if (definitions && definitions.length > 0) {
      const definitionsId = definitions.reduce((acum, current, index) => {
        if (index === 0) return acum + `${current[0].id_Plantilla}`;
        else return acum + `,${current[0].id_Plantilla}`;
      }, '');

      setWorkflowSelected(workflow);
      template.getTemplateInteraction({ query: { templateId: definitionsId }});
      setOpenModalRunJob(true);
    }
  };

  const handleCloseModalRunJob = () => {
    setOpenModalRunJob(false);
    template.cleanUp();
  };

  const alerts = [
    {
      severity: 'error',
      open: job.error.post,
      message: 'workflowList.components.alert.errorJob',
    },
    {
      severity: 'error',
      open: template.error.getRun,
      message: 'workflowList.components.alert.errorJob',
    },
    {
      severity: 'error',
      open: runError,
      message: runError === 2 ? 
                'templateList.components.alert.errorJobInventory' :
                'templateList.components.alert.errorJob'
    },
  ];

  useLayoutEffect(() => {
    handleListPage({ dateFrom: dateFrom, dateTo: dateTo });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project, dateFrom, dateTo]);

  useEffect(() => {
    if (job.success.post) {
      if (job.data && job.data.result === 1 && job.data.job_id){
        history.push(`${ROUTES.JOB_RUN_WORKFLOW}/${job.data.job_id}`);
      } else {
        if (job.data && job.data.mensaje === "Inventario en uso"){
          setRunError(2);
        } else {
          setRunError(1);
        }
      }
    }

    return () => job.cleanUp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [job.success.post]);

  return (
    <>
      { isLoaded ? (
        <Backdrop
          invisible
          sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
          open={true}
        >
          <CircularProgress color="primary" />
        </Backdrop>
      )
      : error ? (
        <ErrorScreen />
      ) : (
        <DashboardDumb
          data={data}
          options={projects}
          handleSearch={handleSearch}
          isLoaded={isLoaded}
          handleRedirect={handleRedirect}
          handleRunJob={handleModalRunJob}
          defaultValues={defaultValues}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => {template.cleanUpMessage(); setRunError(0);}}
          open={alert.open}
          message={alert.message}
        />
      ))}

      { template.job &&
        <ModalJobAlert
          open={openModalRunJob}
          data={template.job}
          handleClose={handleCloseModalRunJob}
          handleConfirm={handleRunJob}
        />
      }
    </>
  )
}

export default withRequest(withRouter(DashboardSmart));
